<SidebarShell
  :logo="short_logo"
  :brand_title="brand_name"
  :brand_subtitle="brand_subtitle"
  :initials="initials"
  :full_name="full_name"
  :is_admin="is_admin"
  @brand-click="select_global_portfolio"
>
  <!-- ✅ FORWARD SIDEBAR HEADER ACTIONS (X BUTTON) -->
  <template #sidebar-header-actions>
    <slot name="sidebar-header-actions"></slot>
  </template>

  <!-- CONTEXT -->
  <template #context>
    <SidebarContext
      :main_label="selected_portfolio"
      :sub_label="portfolio_context_subtitle"
      icon="bi bi-buildings"
      :sectors="sectors"
      active_sector="property"
      :items="tilesFormatted"
      :active_id="local_active_property"
      :open="dropdownOpen"
      :top_label="entity_name"
      top_subtitle="Aggregated Portfolio View"
      :top_active="!local_active_property"
      @toggle="toggleDropdown"
      @select="select_tile_directly"
      @select-top="select_global_portfolio"
      @select-sector="select_sector"
    />
  </template>

  <!-- MENU -->
  <template #menu>
    <div class="sidebar-menu sidebar-menu-list px-3 mt-3">
      <div
        v-for="item in menuItems"
        :key="item.key"
        class="sidebar-menu-item d-flex align-items-center py-2 px-2 rounded-3 cursor-pointer"
        :class="[
          active_menu_item === item.key
            ? 'bg-danger-subtle text-danger border-start border-3 border-danger'
            : 'text-muted'
        ]"
        :aria-label="item.label"
        @click="select_menu_item(item.key)"
      >
        <i
          :class="[
            item.icon,
            'sidebar-menu-icon',
            'me-2',
            active_menu_item === item.key ? 'text-danger' : 'text-muted'
          ]"
          :aria-label="item.label"
        ></i>

        <p class="sidebar-menu-label sidebar-menu-text fw-light text-xs mb-0">
          {{ item.label }}
        </p>
      </div>
    </div>
  </template>
</SidebarShell>
